<template>
  <div class="hello">

    <div class="container">
     <div class="item">

        <a href="https://www.visity.app/" target="_blank" class="logo">
          <img id="image" src="/static/img/visity1.png" width="30%">
        </a>

        <!-- ----------------- Sign Up Form ----------------- -->

        <form class="SignUpForm" @submit.prevent="Submit" v-if="showForm">

          <div class="form-group col-md-12">
            <p id="title">Say Hello!</p>
            <p>Hola amigo! <br>Give us a shout out @ +1 970-231-3006.<br>Or drop us a message & we'll reach out to you...</p>
            <br>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">My name is...</label>
            <input type="text" class="form-control" v-model="FormInfo.ContactPerson" placeholder="First Name Last Name" required>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">and my email is...</label>
            <input type="email" class="form-control" v-model="FormInfo.Email" palceholder="something@somewhere.com" required>
          </div>


          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">you can reach me on...</label>
            <input type="tel" class="form-control" v-model="FormInfo.Mobile" minlength="10" maxlength="10" placeholder="10 digit mobile number" required>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">What's on your mind?</label>
            <textarea class="form-control" v-model="FormInfo.Message"  placeholder="Optional"> </textarea>
          </div>

          <div class="form-group col-md-12 button">
            <input type="submit" value="Submit" class="btn btn-primary btn-block" :disabled="!ValidMobile" />
            <br>
          </div>

        </form>


          <!-- ----------------- Message Templates ----------------- -->

            <template v-if="showSpinner">
              <div class="Message">
                <p class="loadingText">Sit tight!<br>Cooridinating with the postal service...</p>
                <i class="fa fa-circle-o-notch fa-spin fa-4x fa-fw spinner"></i>
              </div>
            </template>

            <template v-if="submitMessage == true">

              <div class="Message">

                    <i class="fa fa-check" aria-hidden="true"></i>

                    <p class="successText">
                      Your message has been dispatched!
                    </p>

                    <p class="successSubText">
                      Someone from Team Visity will reach out to you soon. In the mean time, <br>
                      <a href="https://signup.visity.app" target="_blank" class="SignIn">Click Here</a> to Sign Up for a 15 day Free trial. 
                    </p>              

              </div>

            </template>


        <br>

     </div>


    </div>

    <!-- Footer -->

<!--     <span class="unsplash">Photo by <a href="https://unsplash.com/@youxventures?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText" class="link">You X Ventures</a> on <a href="https://unsplash.com/s/photos/office?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText" class="link">Unsplash</a></span> -->

  </div>
</template>

<script>

import { db } from '../main'
import firebase from 'firebase'
import moment from 'moment';
import Autocomplete from 'vuejs-auto-complete'
import axios from 'axios';

export default {
  name: 'HelloWorld',
  components: {
    Autocomplete,
  },  
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      applications: [],
      CountryCodeList: [
        {Code:"+1", name: "United State of America (+1)"},
        {Code:"+91", name: "India (+91)"}
      ],
      ValidMobile: true,
      show: false,
      showSignUpText: true,
      showForm: true,
      showOTP: false,
      showSpinner: false,
      showSpinner2: false,
      showErrorMsg: false,
      submitMessage: false,
      showButton: false,
      showStatus: false,
      submitLoader: false,
      showNotFound: false,
      statusMessage: "",
      showTable: false,
      CountryCode: "",
      CompanyId: "",
      GeneratedOTP: "",
      InputOTP: "",
      Timer: 4,
      LocationInfo: {},
      FormInfo: {
        CompanyName: "",
        ContactPerson: "",
        Designation: "",
        Mobile: "",
        Email: "",
        CountryCode: ""
      }
    }
  },
  mounted(){
    console.log("Visity Sign Up");


  },
  methods: {   
    SelectCountryCode(){
      // this.FormInfo.Mobile = this.FormInfo.CountryCode;
    },
    CheckMobileFormat(){
  
      this.FormInfo.Mobile = this.FormInfo.CountryCode+this.FormInfo.Mobile;
      console.log("Mobile with Country Code: "+this.FormInfo.Mobile);

      if(this.FormInfo.Mobile.includes("+")){
        this.ValidMobile = true;
      }else{
        console.log("Please Include Country Code");
        this.ValidMobile = false;
      }


    },
    Submit(){

      this.showForm = false;
      this.showSpinner = true;

      console.log("Form Submitted");
      console.log(this.FormInfo);

            // ---------------- Create Organization -----------------------

            console.log("Upload to DB Started");

            this.FormInfo.Timestamp = moment().format();

            console.log("Payload: "+JSON.stringify(this.FormInfo));

              db.collection("Contact-us")
                .add(this.FormInfo)
                .then((res) => {
                  console.log(res);
                  console.log("Contact Us Success");
                  this.showSpinner = false;
                  this.submitMessage = true;

                });     

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

  .container{
     display: flex;
     flex-direction: row;
     align-items: center;
     align-content: center;
     justify-content: center;
     /* height: 80%; */
     /* border: 1px solid red; */
  }

  .item{
     margin-top: 5em;
     margin-bottom: 5em;
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
     border-radius: 2em;
     /*border: 1px solid red; */
     background-color: #ffffff;
     /*opacity: 0.9;*/
  }

  .item2{
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
  }

  .SignUpForm{
    margin-top: 1em;
    text-align: left;
    margin-left: 2em;
    margin-right: 2em;
  }

  #image{
    margin-top: 3em;
  }

  #title{
   margin-top: 1em;
   font-weight: bold;
   font-size: 1.5em;
  }

  #footerMsg{
    font-size: 0.7em;
    font-style: italic;
  }

  #message{
    text-align: left;
    /* padding: em; */
  }

  .button{
    text-align: center;
  }

  .spinner{
    color: #3880ff;
  }

  .unsplash{
    color: #ffffff;
  }

  .logo{
    margin-bottom: 2em;
  }

  .unsplash .link{
    color: #ffffff;
  }

  .mobileInvalid{
    color: red;
  }

  input, select{
    border-radius: 0.5em;
  }

  .loadingText{
    font-size: 1.5em;
    color: #3880ff;
  }

  .fa-exclamation{
    font-size: 5em;
    color: red;
  }

  .errorText{
    font-size: 1.5em;
    color: red;
  }

  .errorSubText{
    font-size: 1em;
  }

  .fa-check{
    font-size: 5em;
    color: #1abc9c;
  }

  .successText{
    font-size: 1.5em;
    font-weight: bold;
    color: #1abc9c;
  }

  .successSubText{
    font-size: 1em;
  }

  .SignIn{
    color: #3880ff;
    cursor: pointer;
  }

  .Message{
    margin-top: 4em;
  }

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue